const GA4_KEY_EVENTS = new Set([
    'user_signed_up',
    'share_link_created',
]);

const GA4_EVENT_ALIASES = {
    image_result_downloaded: 'result_downloaded',
};

let initialized = false;

export function getMixpanelDeviceId() {
    try {
        return window.mixpanel?.get_property?.('$device_id') || null;
    } catch {
        return null;
    }
}

export function initPublicHomeAnalytics(pageVariant) {
    if (initialized) return;
    initialized = true;

    const superProps = {
        entry: 'public_home',
        page_variant: pageVariant,
    };

    try {
        window.mixpanel?.register?.(superProps);
    } catch { /* ignore */ }

    try {
        if (typeof window.gtag === 'function' && window.__PUBLIC_HOME_GA4_ID) {
            window.gtag('set', 'user_properties', { page_variant: pageVariant });
        }
    } catch { /* ignore */ }
}

export function trackAnalyticsEvent(ev, props = {}) {
    const p = {
        entry: 'public_home',
        ...props,
    };

    try {
        window.mixpanel?.track?.(ev, p);
    } catch { /* ignore */ }

    try {
        if (typeof window.gtag !== 'function' || !window.__PUBLIC_HOME_GA4_ID) return;
        const gaName = GA4_EVENT_ALIASES[ev] || ev;
        const gaParams = { ...p };
        if (GA4_KEY_EVENTS.has(ev)) {
            gaParams.value = 1;
        }
        window.gtag('event', gaName, gaParams);
    } catch { /* ignore */ }
}

export function identifyPublicHomeUser(userId) {
    if (!userId) return;
    try {
        window.mixpanel?.identify?.(String(userId));
    } catch { /* ignore */ }
    try {
        if (typeof window.gtag === 'function' && window.__PUBLIC_HOME_GA4_ID) {
            window.gtag('set', { user_id: String(userId) });
        }
    } catch { /* ignore */ }
}

export function trackHomeSignupClient({ method, created, source, pageVariant, useCase }) {
    if (!created) return;
    trackAnalyticsEvent('user_signed_up', {
        entry: 'public_home',
        source: source || 'public_home',
        method,
        ...(pageVariant ? { page_variant: pageVariant } : {}),
        ...(useCase ? { use_case: useCase } : {}),
    });
}

export function trackHomeAbandon(props) {
    const payload = {
        entry: 'public_home',
        ...props,
    };

    try {
        if (window.mixpanel?.track) {
            window.mixpanel.track('home_upload_abandoned', payload, { transport: 'sendBeacon' });
            return;
        }
    } catch { /* ignore */ }

    trackAnalyticsEvent('home_upload_abandoned', payload);
}
